import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextArea, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { CompaniesFormData } from "../../types";

export const NotesField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<CompaniesFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography>Notes</Typography>
      <TextArea className="w-full" placeholder="Enter Notes" hasError={!!errors.notes} maxLength={1024} {...register("notes")} />
      <ErrorMessage errors={errors} name="notes" />
    </div>
  );
};
